export default __webpack_public_path__ + "static/app-features-3-7ab9f45f4fb2a2016c7fa08ac329a4b0.png";